// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"666":"9bad5b3f","878":"9bad5b3f","3911":"9bad5b3f","5274":"9bad5b3f"}[chunkId] + ".chunk.css";
};